<template>
	<FilterComponent
		:title="'Empresa'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "true"
		:useForms= "false"
		:fileOnly= "true"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@delete-data-id= "deleteData"
		@new-alternative="newEntry"
		@edit-alternative= "getEditData"
		@upload-data= "sendImportFile"
		@filter="openFilter = true"
	/>

	<EmpresasForm
		:open= "formOpen"
		:inputsList= "inputs"
		:title= "'Empresas'"
		:resetFormData= "resetFormData"
		@data = "onSendFormData"
		@update-open= "formOpen = false"
	/>
	<EmpresasEditingForm
		:editData="editFormData"
		:open= "editOpen"
		:inputsList="inputs"
		:placeHolderValues="editFormData"
		@update-open= "editOpen = false"
		@editing-data= "onSendEditingData"
		@add-plano= "createPlano"
		@deletar-plano= "deletePlano"
	/>
	<CommonLoading
		v-if="loading"
	/>
</template>
<script>

import Commonlisting from '@/components/generalcomponents/CommonListing';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import PlanosRepository from '@/services/PlanosRepository.vue';
import { pageVariables } from '@/views/insideviews/empresas/PageVariablesEmpresas';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import EmpresasEditingForm from './EmpresasEditingForm.vue';
import EmpresasForm from './EmpresasForm.vue';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';

export default {
	name: 'EmpresasView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.empresasGetPage)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			editFormData:{},
			openFilter: false,
			filters: [],
			formOpen : false,
			editOpen: false,
			editingId: '',
			loading: false,
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome da empresa"
				},
				{
					name: "cnpj",
					label: "CNPJ",
					type: "input",
					placeholder: "Digite o CNPJ"
				},
				{
					name: "email",
					label: "Email",
					type: "input",
					placeholder: "Digite o email da empresa"
				},
			]
		
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresas(this.onlineUser.token,page,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				console.log(data)
				const response = await empresasRepo.createEmpresa(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.empresasGetPage);
					this.resetForm();
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.loading = false;
				}
			} catch (error) {
				handleUnauthorized(error);
				this.loading = false; 
			}	
		},
		async onSendEditingData(data,id){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.updateEmpresa(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.loading = false; 
					this.pageData(this.empresasGetPage);
					this.mostrarAlerta();
				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.deleteEmpresa(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.loading = false; 
					this.pageData(this.empresasGetPage);
					this.mostrarAlerta();

				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		async createPlano(data){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.createPlano(this.pagePlanos,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.loading = false; 
					this.getEditData(this.editingId);
					this.mostrarAlerta();

				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error)
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		async deletePlano(id){
			this.loading = true; 
			const planoRepo = new PlanosRepository();
			try {
				const response = await planoRepo.deletePlano(this.pagePlanos,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.loading = false; 
					this.getEditData(this.editingId);
					this.mostrarAlerta();

				} else {
					this.loading = false; 
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		async getEditData(id){
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresa(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.editFormData = response.data;
					this.editOpen = true;
					this.editingId = this.editFormData.id;
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async sendImportFile(data){
			this.loading = true; 
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.importEmpresaFile(data,this.onlineUser.token,this.uploadDataPage);
				if (response?.status === 201) {
					this.loading = false; 
					this.mostrarAlertaUpload();
				} else {
					this.loading = false; 
					this.mostrarAlertaErro(response?.message)
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.empresasGetPage+"?page="+number)
		},
		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.empresasGetPage);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},
		mostrarAlertaUpload() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'Arquivo recebido acompanhe o progresso pela página de Uploads',
				confirmButtonColor: '#3085d6', 
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
		newEntry(){
			this.formOpen = true;
		}
	},
	components:{
		Commonlisting,
		FilterComponent,
		EmpresasEditingForm,
		EmpresasForm,
		CommonLoading
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
